export default __webpack_public_path__ + "static/media/abstraction-layers.61ed5ae2.jpg";